import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/functions'


const firebaseConfig = {
  apiKey: "AIzaSyCjJrN1adhug-_vLrCKWPJ8FT0jK6-XSa4",
  authDomain: "das-rad-gc.firebaseapp.com",
  projectId: "das-rad-gc",
  storageBucket: "das-rad-gc.appspot.com",
  messagingSenderId: "310059750265",
  appId: "1:310059750265:web:2a8a0fb136800b359c15a8"
};

  firebase.initializeApp(firebaseConfig);
  firebase.firestore().enablePersistence().catch(err => {
    console.log(err)
  })
  

  export default firebase;